import React from "react";
import Certification from "../../components/Certification/Certification";
// import Highlight from "../../components/HighLight/Highlight";
import Mission from "../../components/Mission/Mission";
import Programs from "../../components/Programs/Programs";
// import Showcase from "../../components/Showcase/Showcase";
import MySlider from "../../components/Slider/MySlider";
import WhatWedo from "../../components/WhatWedo/WhatWedo";
//import Slider from "../../components/Slider/Slider";
import SupportResources from "../../components/HomeSections/SupportResources";
import CareerRoadmap from "../../components/HomeSections/CareerRoadmap";
import PersonalGuidance from "../../components/HomeSections/PersonalGuidance";
import InteractiveCareer from "../../components/HomeSections/InteractiveCareer";
import TakeFreeDemo from "../../components/HomeSections/TakeFreeDemo";
import ConfusedAbout from "../../components/HomeSections/ConfusedAbout";
import GallerySlider from "../../components/Gallery/GallerySlider"; 


function Home() {
  return (
    <div>
      
      <MySlider />
      {/* <Showcase /> */}
      <ConfusedAbout />
      <WhatWedo />
      <GallerySlider />

      <SupportResources />
      <CareerRoadmap />
      <PersonalGuidance />
      <InteractiveCareer />
      <TakeFreeDemo />
      <Programs />
      <Mission />
      <Certification />
    </div>
  );
}

export default Home;
